module.exports = "/_next/static/images/video_id_7172212795373669674-a4609d0dd062e3a59398b1307c2165b5.jpg";